import {
    Avatar,
    Box,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
} from "@material-ui/core";
import { RadioButtonChecked, RadioButtonUnchecked } from "@material-ui/icons";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import _ from "underscore";
import uploadingImg from "../../assets/images/loading.jpg";
import { fetchPaymentConfigRequest } from "../../store/shopping/shopping.actions";
import {
    getCategoryList,
    getPaymentConfig,
} from "../../store/shopping/shopping.selector";
import SocialAPI from "../../store/social/social.api";
import { getUserPrivateLounge } from "../../store/user/privatelounge/privatelounge.selector";
import { fetchOtherUserProfileRequest } from "../../store/user/user.actions";
import {
    getImage,
    getOtherUserProfile,
    getUserProfile,
} from "../../store/user/user.selector";
import StripePaymentForm from "../payment/stripePaymentForm";
var stripePromise = null;
const ELEMENTS_OPTIONS = {
    fonts: [
        {
            cssSrc: "https://fonts.googleapis.com/css?family=Roboto",
        },
    ],
};

export default function SubscriptionPayment(props) {
    const dispatch = useDispatch();
    const history = useNavigate();
    const location = useLocation();
    const [period, setPeriod] = useState("Yearly");
    const [canPayUsingCard, setPayUsingCard] = useState(false);

    useState(() => {
        if (location && location.state && location.state.period) {
            setPeriod(location.state.period);
        }
    }, [location]);

    const {
        userProfile,
        categories,
        otherUserProfile,
        paymentConfig,
        userPrivateLounge,
    } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
            otherUserProfile: getOtherUserProfile(state),
            paymentConfig: getPaymentConfig(state),
            userPrivateLounge: getUserPrivateLounge(state),
            categories: getCategoryList(state),
        };
    });

    useEffect(() => {
        if (!paymentConfig || !paymentConfig.publicKey) {
            dispatch(fetchPaymentConfigRequest());
        }
    }, []);

    useEffect(() => {
        if (paymentConfig && paymentConfig.publicKey) {
            stripePromise = loadStripe(paymentConfig.publicKey);
        }
    }, [paymentConfig]);

    const handleSave = () => {
        let mail = ` <p style="text-align: center;
        background: #8B22F9;
        color: white;
        font-weight: bold;
        line-height: 28px;
        font-size: 20px;
        padding: 12px;">
            Congrats, ${otherUserProfile.fullName}!<br />
            You have a new subscriber
        </p>
        <hr style="border: 1px dashed" />
        <p style="line-height: 30px">
            Hello <span style="color:#8B22F9">${otherUserProfile.fullName}</span>,<br />
            Lets have round applause because you did it!, You have a new subscriber and more to come, so now its time to
            get out there and shout from the virtual
            rooftops!
        </p>

        <p style="text-align: center;padding: 16px;">
            <a href="https://app.ulalive.com/${userProfile.userName}" style="background: #8B22F9;
            color: white;
            padding: 16px;
            text-decoration: none;
            border-radius: 16px;
            font-weight: bold;">
                See Your Subscriber
            </a>
        </p>`;

        SocialAPI.sendEmailNotification({
            message: mail,
            subject: "New Subscriber from Ulalive Private Hall",
            to: otherUserProfile.email,
        });

        Swal.fire({
            title: "Subscription Successful",
            text: `You have successfully subscribed to ${otherUserProfile.fullName}. Please wait for sometime to confirm the subscription.`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "green",
            confirmButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(
                    fetchOtherUserProfileRequest(
                        otherUserProfile.id || otherUserProfile._id,
                        history
                    )
                );
            }
        });
    };

    const handleConfirmCard = () => {
        setPayUsingCard(true);
        setTimeout(() => {
            setPayUsingCard(false);
        }, 1000);
    };

    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
            <div className="mb-[25px]">
                <h2 className="text-xl font-bold text-ebony-color">
                    Subscribe
                </h2>
                <p className="text-sm font-medium text-black-50">
                    Please pay the subscription to watch private lounge
                    livestreams.
                </p>
            </div>
            <div className="flex-1 overflow-y-auto p-4 pb-0 bg-white rounded-lg border border-black-10">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} className="mt-2">
                        <Grid container spacing={1}>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                className="mt-2"
                            >
                                <List disablePadding>
                                    <ListItem disableGutters>
                                        <ListItemAvatar>
                                            <Avatar
                                                style={{
                                                    height: 64,
                                                    width: 64,
                                                }}
                                                className="mr-2"
                                                src={
                                                    otherUserProfile.avatar
                                                        ? getImage(
                                                              otherUserProfile
                                                                  .avatar
                                                                  .attachments
                                                          )
                                                        : getImage(
                                                              otherUserProfile.attachments
                                                          )
                                                }
                                            />
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={otherUserProfile.fullName}
                                            secondary={
                                                userPrivateLounge.description
                                            }
                                        />
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <h3 className="text-base font-bold text-ebony-color mb-2">
                                    Subscription Type
                                </h3>
                                <Box
                                    display="flex"
                                    justifyContent="space-evenly"
                                    className="my-4"
                                >
                                    <p
                                        onClick={() => {
                                            setPeriod("Monthly");
                                        }}
                                        style={{
                                            color:
                                                period === "Monthly"
                                                    ? "#0038FF"
                                                    : "black",
                                            border:
                                                period === "Monthly"
                                                    ? "1px solid #0038FF"
                                                    : "1px solid #CECECE",
                                        }}
                                        className="text-medium text-center p-3 rounded-xl w-full mr-2"
                                    >
                                        {period === "Monthly" ? (
                                            <RadioButtonChecked />
                                        ) : (
                                            <RadioButtonUnchecked />
                                        )}
                                        <span className="text-bold text-large mx-2">
                                            {userPrivateLounge.currencySubscription +
                                                " " +
                                                userPrivateLounge.monthlySubscription}
                                        </span>
                                        / month
                                    </p>
                                    <p
                                        onClick={() => {
                                            setPeriod("Yearly");
                                        }}
                                        style={{
                                            color:
                                                period === "Yearly"
                                                    ? "#0038FF"
                                                    : "black",
                                            border:
                                                period === "Yearly"
                                                    ? "1px solid #0038FF"
                                                    : "1px solid #CECECE",
                                        }}
                                        className="text-medium text-center p-3 rounded-xl w-full ml-2"
                                    >
                                        {period === "Yearly" ? (
                                            <RadioButtonChecked />
                                        ) : (
                                            <RadioButtonUnchecked />
                                        )}
                                        <span className="text-bold text-large mx-2">
                                            {userPrivateLounge.currencySubscription +
                                                " " +
                                                userPrivateLounge.annuallySubscription}
                                        </span>
                                        / year
                                    </p>
                                </Box>
                                <div className="bg-white rounded-full border border-black-10 rounded-xl p-3">
                                    <h3 className="text-base font-bold text-ebony-color my-2">
                                        Order Summary
                                    </h3>
                                    <div className="flex justify-between items-center my-2">
                                        <span className="text-black-50">
                                            {period} subscription
                                        </span>
                                        <span className="text-black-50">
                                            {
                                                userPrivateLounge.currencySubscription
                                            }{" "}
                                            {period === "Yearly"
                                                ? userPrivateLounge.annuallySubscription.toFixed(
                                                      2
                                                  )
                                                : userPrivateLounge.monthlySubscription.toFixed(
                                                      2
                                                  )}
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-center my-2">
                                        <span className="text-black-50">
                                            Tax Fee
                                        </span>
                                        <span className="text-black-50">
                                            {
                                                userPrivateLounge.currencySubscription
                                            }{" "}
                                            0.00
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-center my-2">
                                        <span className="text-black-50">
                                            Total
                                        </span>
                                        <span className="text-orange-color">
                                            {
                                                userPrivateLounge.currencySubscription
                                            }{" "}
                                            {period === "Yearly"
                                                ? userPrivateLounge.annuallySubscription.toFixed(
                                                      2
                                                  )
                                                : userPrivateLounge.monthlySubscription.toFixed(
                                                      2
                                                  )}
                                        </span>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} className="mt-2">
                        {stripePromise &&
                        paymentConfig &&
                        paymentConfig.publicKey ? (
                            <>
                                <Elements
                                    stripe={stripePromise}
                                    options={ELEMENTS_OPTIONS}
                                >
                                    <StripePaymentForm
                                        type="user-subscription"
                                        categories={categories}
                                        userId={
                                            otherUserProfile._id ||
                                            otherUserProfile.id
                                        }
                                        isPaying={canPayUsingCard}
                                        billingPeriod={period}
                                        paymentConfig={paymentConfig}
                                        onCancel={() => {
                                            let pvHall = _.find(
                                                categories,
                                                (x) => x.name === "Private Hall"
                                            );
                                            if (
                                                pvHall &&
                                                otherUserProfile.userName
                                            ) {
                                                history(
                                                    "/user/" +
                                                        otherUserProfile.userName,
                                                    {
                                                        state: {
                                                            category:
                                                                pvHall._id,
                                                        },
                                                    }
                                                );
                                            } else {
                                                history.goBack();
                                            }
                                        }}
                                        userProfile={userProfile}
                                        OnSuccess={handleSave}
                                        OnError={(err) =>
                                            Swal.fire({
                                                title: "Error Occured",
                                                text: err.message,
                                                icon: "error",
                                                showCancelButton: false,
                                                cancelButtonText: "Cancel",
                                                confirmButtonText: "Close",
                                                customClass: {
                                                    cancelButton:
                                                        "order-1 right-gap",
                                                    confirmButton: "order-2",
                                                    denyButton: "order-3",
                                                },
                                            })
                                        }
                                    />
                                </Elements>
                            </>
                        ) : (
                            <div className="flex items-center justify-center">
                                <img src={uploadingImg} className="rotate" />
                            </div>
                        )}
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}
